import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import GoogleMap from "./map";

export const Contact = () => {
  const form = useRef();
  const [from_name, setFrom_Name] = useState("");
  const [from_email, setFrom_Email] = useState("");
  const [message, setMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = { from_name, from_email, message };

    try {
      const result = await axios.post(
        "/api/addNotification",
        formData,
        { headers: { "Content-Type": "application/json" } }
      );
      if (result.data.status === "ok") {

        console.log("saved to database successfully..")
      }
    } catch (error) {
      console.error("Error sending form data:", error);
    }

    emailjs
      .sendForm("service_1lwfmjn", "template_2pumce9", form.current, {
        publicKey: "4R4i1hnzldugIHfP4",
      })
      .then(
        () => {
          setShowPopup(true);
          setTimeout(() => setShowPopup(false), 3000);
          setFrom_Name("");
          setFrom_Email("");
          setMessage("");
        },
        (error) => {
          console.log("FAILED...", error.text);
        }
      );
  };

  return (
    <div className="contact-section">
      <div className="contact-container">
        {/* Left Info Section */}
        <motion.div
          className="contact-info"
          initial={{ x: -200, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <h2>Ready to help you!</h2>
          <p>We’re here to help and answer any questions you might have.</p>

          <h3>Contact Info</h3>
          <p>
            <strong>Address:</strong> Office No. 303, 313, A Wing, Laxmi
            Horizon, HDFC Bank, Mumbai-Bangaluru Highway, Punawale, Pune - 411033
          </p>
          <p>
            <strong>Phone:</strong> 020 47211265
          </p>
          <p>
            <strong>Email:</strong> info@configserverllp.com
          </p>
        </motion.div>
        {/* Right Form Section */}
        <motion.div
          className="contact-form"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h2>Looking for any help?</h2>
          <form ref={form} onSubmit={handleSubmit}>
            <input
              type="text"
              name="from_name"
              placeholder="Enter your name"
              value={from_name}
              onChange={(e) => setFrom_Name(e.target.value)}
              required
            />
            <input
              type="email"
              name="from_email"
              placeholder="Enter your email"
              value={from_email}
              onChange={(e) => setFrom_Email(e.target.value)}
              required
            />
            <textarea
              name="message"
              placeholder="Enter your message"
              rows="4"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            />
            <button type="submit">Send Message</button>
          </form>
        </motion.div>
      </div>
      <div className="contact-map">
        <GoogleMap />
      </div>

      {/* Popup Animation */}
      <AnimatePresence>
        {showPopup && (
          <motion.div
            className="popup-message"
            initial={{ y: 100, opacity: 0, scale: 0.8 }}
            animate={{ y: 0, opacity: 1, scale: 1 }}
            exit={{ y: 100, opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.5 }}
          >
            ✅ Your message has been sent successfully!
          </motion.div>
        )}
      </AnimatePresence>

      {/* Google Map BELOW form */}
      
    </div>
  );
};
